export default __webpack_public_path__ + "static/media/risk_level_1.a2200eae.png";